import { hasYesOrNo } from 'models/validate';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { isSafeUnitedStates } from 'helpers/locations';
import { setToStartOfMonth } from 'helpers/date';
import { FormDetails } from 'util/singletons';
import {
  SF85, SF85P, SF85PS, SF86
} from 'constants/formTypes';
import { formIncludesPvqPartB, isPVQForm } from 'helpers/form';
import { CitizenshipMultipleItemModel } from '../types';
import { pvqForeignPassportValidator } from './pvqForeignPassportValidator';

const citizenshipItemValidator: ValidateJSModel<CitizenshipMultipleItemModel> = {
  Country: (value, attributes, attributeName, options) => {
    if (attributes?.CountryFocused) {
      return {};
    }

    return {
      presence: true,
      country: { duplicateData: options?.duplicateData },
      hasValue: true,
    };
  },

  Dates: (value, attributes, attributeName, options) => {
    const { applicantBirthdate, requireCitizenshipMultipleDates } = options;
    if (requireCitizenshipMultipleDates) {
      return {
        presence: true,
        daterange: {
          earliest: setToStartOfMonth(applicantBirthdate),
          latest: DEFAULT_LATEST,
        },
      };
    }

    return {};
  },

  Current: (value, attributes, attributeName, options) => {
    const formDetails = FormDetails.getInstance().getData();
    if (isPVQForm(formDetails.formType)) { return {}; }

    if (!attributes?.Dates?.present
      && options?.requireCitizenshipMultipleCurrent
      && [SF85P, SF85PS, SF86].includes(formDetails.formType || '')) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    if (attributes?.Dates?.present
      && options?.requireCitizenshipMultipleCurrent
      && [SF85].includes(formDetails.formType || '')) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },

  CurrentExplanation: (value, attributes, attributeName, options) => {
    const formDetails = FormDetails.getInstance().getData();
    if (isPVQForm(formDetails.formType)) { return {}; }

    if (!attributes?.Dates?.present
      && options?.requireCitizenshipMultipleCurrent
      && [SF85P, SF85PS, SF86].includes(formDetails.formType || '')) {
      return { presence: true, hasValue: true };
    }
    if (attributes?.Dates?.present
      && options?.requireCitizenshipMultipleCurrent
      && [SF85].includes(formDetails.formType || '')) {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  CurrentComments: {},
  Comments: {},

  How: (value, attributes, attributeName, options) => {
    if (options?.requireCitizenshipMultipleHow === false) { return {}; }
    if (isSafeUnitedStates(attributes?.Country)) { return {}; }

    return {
      hasValue: true,
    };
  },

  Renounced: (value, attributes, attributeName, options) => {
    const formDetails = FormDetails.getInstance().getData();
    if (isPVQForm(formDetails.formType)) { return {}; }

    if (options?.requireCitizenshipRenounced === false) { return {}; }
    if (isSafeUnitedStates(attributes?.Country)) { return {}; }

    return {
      hasValue: { validator: hasYesOrNo },
    };
  },

  RenouncedExplanation: (value, attributes, attributeName, options) => {
    const formDetails = FormDetails.getInstance().getData();
    if (isPVQForm(formDetails.formType)) { return {}; }

    if (options?.requireCitizenshipRenounced === false) { return {}; }
    if (isSafeUnitedStates(attributes?.Country)) { return {}; }

    return {
      hasValue: true,
    };
  },

  EverIssuedPassport: (value, attributes, attributeName, options) => {
    const formDetails = FormDetails.getInstance().getData();
    if (!isPVQForm(formDetails.formType)) { return {}; }

    return { presence: true, hasValue: { validator: hasYesOrNo } };
  },

  IsPassportActive: (value, attributes, attributeName, options) => {
    const formDetails = FormDetails.getInstance().getData();
    if (!isPVQForm(formDetails.formType) || attributes?.EverIssuedPassport?.value !== 'Yes') {
      return {};
    }

    return { presence: true, hasValue: { validator: hasYesOrNo } };
  },

  ForeignPassports: (value, attributes, attributeName, options) => {
    if (formIncludesPvqPartB(options?.formType)) {
      return {
        presence: true,
        branchCollection: {
          validator: pvqForeignPassportValidator,
        },
      };
    }

    return { };
  }
};

export default citizenshipItemValidator;
